import clsx from "clsx";
import { Route, Routes, useLocation } from "react-router-dom";
import Agent from "../pages/agent";
import MessageTemplates from "../pages/message-templates";
import CreateChase from "../pages/create-chase";
import ChaseList from "../pages/chase-list";
import Dashboard from "../pages/dashboard";
import LeftSidebar from "./left-sidebar";
import Auth from "../pages/auth";
import ResetPassword from "../pages/reset-password";
import GraphProvider from "../providers/graphs-provider";
import LowScreen from "./low-screen";
import { useSidebar } from "../store/use-sidebar";

function MainComponent() {
  const location = useLocation();
  const { collapsed } = useSidebar();
  const hideSideBarRoutes = [
    "createChase",
    "createInsurer",
    "auth",
    "reset",
    "chat",
  ];

  return (
    <GraphProvider>
      <LowScreen />
      <div className="flex justify-between min-h-screen bg-background flex-grow">
        {!hideSideBarRoutes?.includes(location.pathname.split("/")[1]) ? (
          <div
            className={clsx(
              "min-h-screen sticky top-0 transition-[width] duration-300 ease-out",
              collapsed
                ? "w-[76px] min-w-[76px] shrink-0"
                : "flex-1 flex-grow w-[32%]"
            )}
          >
            <LeftSidebar />
          </div>
        ) : null}
        <div
          className={clsx(
            "flex-2 min-h-screen h-full flex-grow  bg-background w-[68%] ml-auto"
          )}
        >
          <Routes>
            <Route
              path="/"
              element={
                <GraphProvider>
                  <Dashboard />
                </GraphProvider>
              }
            />
            <Route path="/chaselist" element={<ChaseList />} />
            <Route path="/chase/:id" element={<ChaseList />} />
            <Route path="/my-customers" element={<ChaseList />} />
            <Route path="/customer-archives" element={<ChaseList />} />

            <Route path="/createChase" element={<CreateChase />} />
            <Route path="/agents" element={<Agent />} />
            <Route path="/message-templates" element={<MessageTemplates />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/reset" element={<ResetPassword />} />
          </Routes>
        </div>
      </div>
    </GraphProvider>
  );
}

export default MainComponent;
